import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../redux/actions'
import autobind from 'react-autobind'
import Alert from './../components/Errors/Alert'
import AlertSuccess from './../components/Success/Alert'
import { Link } from 'react-router-dom';

import logo from './../img/indexAR-logo-white.png';
import sponsor1 from './../img/sponsor1.png';
import sponsor2 from './../img/sponsor2.png';
import sponsor3 from './../img/sponsor3.png';
import { ClipLoader } from 'react-spinners'

class ForgotPasswordRequestPage extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            email: "",
            emailSent: false
        };
        autobind(this)
    }

    onEmailChange(event) {
        this.setState({ email: event.target.value });
    }

    onRequestForgotPasswordClick(e) {
        e.preventDefault();
        this.props.requestResetPassword(this.state.email, () => {
            this.setState({
                emailSent: true
            })
        });
    }

    render() {
        const { email, emailSent } = this.state;
        const { requestResetPasswordError, requestResetPasswordInProgress } = this.props
        return (
            <div className="white-bg-top-wrapper">
                <div className="splash-wrapper">
                    <div className="d-flex justify-content-between flex-wrap mb-5">
                        <img src={sponsor1} width="135" height="107" alt="Sponsor" />
                        <img src={sponsor2} width="114" height="114" alt="Sponsor" />
                        <img src={sponsor3} width="127" height="120" alt="Sponsor" />
                    </div>
                    <div className="splash-container row">
                        <img src={logo} alt="logo" width="117" height="102" className="logo-img mb-4 login-logo" />
                        <div className="col-sm-6 user-message">
                            <span className="splash-message text-right">Oops!<br /> this will take<br /> just a moment.</span>
                            <span className="alternative-message alternative-message-register">You don't have an account? <Link to="/register">Register here!</Link></span>
                        </div>
                        <div className="col-sm-6 form-message d-flex justify-content-center">
                            <div>
                                <span className="splash-description text-center mt-5 mb-5">
                                    Don't worry, we'll send you an email to reset your password.
                                    </span>
                                {emailSent ? <AlertSuccess message="Check your email to reset your password." /> : (
                                    requestResetPasswordError ? <Alert message={requestResetPasswordError} /> : null
                                )}
                                {requestResetPasswordInProgress ? (
                                    <div className="w-100 text-center">
                                        <ClipLoader
                                            color={'#2CC185'}
                                            loading={true}
                                            className="d-inline-block"
                                        />
                                    </div>
                                ) : null}
                                <form>
                                    <div className="form-group">
                                        <div className="input-group"><span className="input-group-addon"><i className="icon s7-mail"></i></span>
                                            <input type="email" placeholder="Email" autoComplete="off" className="form-control"
                                                onChange={this.onEmailChange}
                                                value={email} />
                                        </div>
                                    </div>
                                    <div className="form-group login-submit upload-product-loader-container">
                                        <button data-dismiss="modal" type="submit" className="btn btn-lg btn-primary btn-block" onClick={this.onRequestForgotPasswordClick}>Reset password</button>
                                        <div className="upload-product-loader" style={{ top: 33, right: -37 }}>

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-px-100">
                        <p className="mb-2 disclaimer-text">Pentru informaţii detaliate despre celelalte programe cofinanţate de Uniunea Europeană, vă invităm să vizitaţi <a href="http://www.fonduri-ue.ro">www.fonduri-ue.ro</a></p>
                        <p className="text-xs">Conţinutul acestui material nu reprezintă în mod obligatoriu poziţia oficială a Uniunii Europene sau a Guvernului României</p>
                    </div>
                </div>
            </div >
        );
    }
}

export default connect(
    (state, ownProps) => {
        const { auth: { requestResetPasswordError, requestResetPasswordInProgress } } = state
        return { requestResetPasswordError, requestResetPasswordInProgress }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps, { alertSomething: (text) => { alert(text) } })
    }
)(ForgotPasswordRequestPage)



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordRequest.js